import React, { Fragment, useCallback, useEffect, useRef, useState } from "react"
import { Empty, Badge, Button, Select, Spin } from "antd"
import { useIsAuthenticated, useMsal } from "@azure/msal-react"
import { useNavigate } from "react-router"
import { Report } from "notiflix"
import moment from "moment"

import Navbar from "../../../atoms/navbar"
import Footer from "../../../atoms/footer"
import "./styles.css"

import { loginRequest } from "../../../config/api.config"
import { requestToken } from "../../../auth/AuthServices"

import { InitializeTicket } from "../../../redux/action"
import HeaderFarms from "../../../utils/header_farms"
import { connect } from "react-redux"
import API from "../../../services"
import { PlusOutlined } from "@ant-design/icons"

const LIMIT = 5

function SRHistory() {
  let navigate = useNavigate()
  const { Option } = Select

  const { instance } = useMsal()
  const isAuthenticated = useIsAuthenticated()

  const [historySR, setHistorySR] = useState([])
  const [page, setPage] = useState(1)
  const [hasMore, setHasMore] = useState(true)
  const [loading, setLoading] = useState(false)
  const [loadingMore, setLoadingMore] = useState(false)
  const [filter, setFilter] = useState("Waiting Approval")

  const sentinelRef = useRef(null)
  const isFirstMountRef = useRef(true)

  function handleLogin(instance) {
    instance
      .loginRedirect(loginRequest)
      .then(res => {})
      .catch(e => {
        console.error(e)
      })
  }

  function handleChange(value) {
    setFilter(value)
  }

  const fetchPage = useCallback(
    async (pageNum, reset = false) => {
      if (!reset) setLoadingMore(true)
      try {
        const accessToken = await requestToken()
        if (!accessToken) {
          handleLogin(instance)
          return
        }
        const res = await API.SRHistory(HeaderFarms(accessToken), {
          page: pageNum,
          limit: LIMIT,
          status: filter,
        })
        const items = res.data || []
        setHistorySR(prev => (reset ? items : [...prev, ...items]))
        setHasMore(res.pagination?.hasMore ?? false)
        setPage(pageNum)
      } catch (err) {
        console.error(err)
        Report.warning("Oops.. something wrong", "Sorry, this application is experiencing problems", "Okay")
        setHasMore(false)
      } finally {
        setLoading(false)
        setLoadingMore(false)
      }
    },
    [filter, instance]
  )

  function goDetail(id) {
    navigate(`/sr/view/${id}`)
  }

  const statusConfig = {
    "Waiting Approval": {
      color: "#FF9900",
      title: data => data.fullname + " - " + data.type_request,
    },
    Approved: {
      color: "blue",
      title: data => data.fullname + " - " + data.type_request,
    },
    Reject: {
      color: "red",
      title: data => data.fullname + " - " + data.type_request,
    },
    Cancel: {
      color: "green",
      title: data => data.fullname + " - " + data.type_request,
    },
    Closed: {
      color: "green",
      title: data => data.fullname + " - " + data.type_request,
    },
  }

  useEffect(() => {
    if (!isAuthenticated) return
    // Skip spinner saat first mount, tampilkan hanya saat ganti filter
    if (!isFirstMountRef.current) {
      setLoading(true)
    }
    isFirstMountRef.current = false
    setLoadingMore(false)
    setHistorySR([])
    setPage(1)
    setHasMore(true)
    fetchPage(1, true)
  }, [isAuthenticated, filter, fetchPage])

  useEffect(() => {
    if (!sentinelRef.current || !hasMore || loading || loadingMore) return
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) fetchPage(page + 1, false)
      },
      { rootMargin: "100px" }
    )
    observer.observe(sentinelRef.current)
    return () => observer.disconnect()
  }, [hasMore, loading, loadingMore, page, fetchPage])

  return (
    <Fragment>
      <Navbar title="History" back={true} subtitle="Service Request" navigate="/home"></Navbar>
      <div className="container white-back-cr" style={{ minHeight: 500 }}>
        <div className="container mt-3 p-3">
          <div className="d-flex justify-content-between align-items-center mb-3" style={{ flexWrap: "wrap", gap: 8 }}>
            <Button type="primary" icon={<PlusOutlined />} onClick={() => navigate("/sr/create")} size="middle">
              New Request
            </Button>

            <div className="d-flex align-items-center" style={{ gap: 8 }}>
              <span style={{ color: "#595959" }}>Filter</span>
              <Select defaultValue="Waiting Approval" style={{ width: 140 }} onChange={handleChange}>
                <Option value="Waiting Approval">Waiting</Option>
                <Option value="Approved">Approved</Option>
                <Option value="Reject">Reject</Option>
                <Option value="Closed">Closed</Option>
                <Option value="Cancel">Cancel</Option>
              </Select>
            </div>
          </div>

          <div className="row">
            <div className="col-md-10 offset-md-1">
              {historySR.map((data, index) => {
                const config = statusConfig[data.approval?.status]
                if (!config) return null

                return (
                  <Fragment key={data.form_record || index}>
                    <Badge.Ribbon color={config.color} text={data.approval.status}>
                      <div className="list-style p-3 px-4 mb-3" onClick={() => goDetail(data.form_record)}>
                        <div className="title mb-1">
                          <p style={{ fontSize: 11 }} className="mb-0">
                            {config.title(data)}
                          </p>
                        </div>
                        <div className="">
                          <p
                            style={{
                              fontSize: 10,
                              display: "-webkit-box",
                              WebkitLineClamp: 1,
                              WebkitBoxOrient: "vertical",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                            className="mb-0"
                          >
                            {data.description}
                          </p>
                        </div>
                        <div className="hour d-flex justify-content-between">
                          <p style={{ color: "#B7B7B7", fontSize: 11 }}>{moment(data.created_at).format("LLL")}</p>
                        </div>
                      </div>
                    </Badge.Ribbon>
                  </Fragment>
                )
              })}

              <div ref={sentinelRef} style={{ height: 1 }} />

              {(loading || loadingMore) && (
                <div className="text-center mt-3" style={{ color: "#B7B7B7" }}>
                  <Spin size={loading ? "large" : "default"} />
                </div>
              )}

              {!loading && !loadingMore && !hasMore && historySR.length > 0 && (
                <div className="fs-6 text-center mt-5" style={{ color: "#B7B7B7" }}>
                  No more data
                </div>
              )}

              {!loading && !loadingMore && historySR.length === 0 && (
                <Empty
                  className="mt-5"
                  description={
                    <span style={{ color: "#8c8c8c" }}>
                      Tidak ada Service Request dengan status <b>"{filter}"</b>.
                      <br />
                      Coba pilih filter lain di kanan atas, atau klik <b>+ New Request</b> untuk membuat baru.
                    </span>
                  }
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </Fragment>
  )
}

const reduxState = state => ({
  initializeTicket: state.initializeTicket,
})

const reduxDispatch = dispatch => ({
  setInitializeTicket: (navigate, data) => dispatch(InitializeTicket(navigate, data)),
})

export default connect(reduxState, reduxDispatch)(SRHistory)
